import { Pagination } from '@/models/pagination.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PaginationProps {
  current_page: number;
  last_page: number;
  total: number;
  per_page: number;
}

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  INITIAL_PAGE = 0;
  @Input() alternativeText = 'Resultados';
  @Input() pagination!: Pagination<any>;

  @Output() pageChanges = new EventEmitter<number>();

  get totalPages() {
    return Math.ceil(this.pagination.totalItems / this.pagination.pageSize);
  }

  get totalPagesFakeArray() {
    return new Array(this.totalPages);
  }

  next() {
    if (this.pagination.pageNumber < this.totalPages) {
      this.pageChanges.emit(this.pagination.pageNumber + 1);
    }
  }

  previous() {
    if (this.pagination.pageNumber > this.INITIAL_PAGE) {
      this.pageChanges.emit(this.pagination.pageNumber - 1);
    }
  }

  setPage(page: number) {
    this.pageChanges.emit(page);
  }

  get altFormattedText() {
    const result = this.pagination.pageNumber * this.pagination.pageSize + 1;
    const renderedQuantity =
      this.pagination.pageNumber * this.pagination.pageSize +
      this.pagination.items.length;

    return `Mostrando ${result} a ${renderedQuantity} de ${this.pagination.totalItems} ${this.alternativeText}`;
  }
}
